import { AddressProvider } from '@address/address-provider'
import { useTranslate } from '@c3po/i18n'
import { Alert, AlertButton, Header, Content, Footer } from '@kawaui/alert'
import { Auth } from '@narf/auth'
import ExpiredSessionError from '@narf/error'

import React from 'react'

import { UNAUTH_ERROR } from 'constants/index'
import { AlertProvider, useAlert } from 'store/alert/reducer'
import * as expSessionAction from 'store/expiredsession/actions'
import { ExpSessionProvider, useExpSession } from 'store/expiredsession/reducer'
import { NotificationContainer } from 'styles/sharedStyles'

import { HandleAuth } from './auth'
import { Theme } from './theme'

const HandleExpSession = () => {
  const { state, dispatch } = useExpSession()

  const onCloseExpSession = () => {
    // TODO (juan.rueda): consider creating a joint action for these two
    expSessionAction.setOnReAuth(dispatch)(false)
    expSessionAction.setOpenExpSession(dispatch)(false)
  }

  const onReAuth = () => {
    expSessionAction.setOnReAuth(dispatch)(true)
  }

  return (
    <>
      <ExpiredSessionError
        {...{
          open: state.openExpSession,
          onReAuth,
          onClose: onCloseExpSession,
        }}
        {...UNAUTH_ERROR}
      />
    </>
  )
}

const HandleAlert = () => {
  const { i18n } = useTranslate()
  const { state } = useAlert()
  return (
    <Alert open={state.isOpen}>
      <Header>{i18n('errors.something_failed.modal.title')}</Header>
      <Content>{i18n('errors.something_failed.modal.text')}</Content>
      <Footer>
        <AlertButton onClick={() => window.location.reload()}>{i18n('common.close')}</AlertButton>
      </Footer>
    </Alert>
  )
}

type Props = {
  children: React.ReactNode
  pageNameKey?: string
}

const PageProviders = ({ children, pageNameKey }: Props) => {
  return (
    <Auth>
      <Theme>
        <HandleAuth pageNameKey={pageNameKey}>
          <AddressProvider>
            <ExpSessionProvider>
              <AlertProvider>
                <HandleExpSession />
                <HandleAlert />
                <NotificationContainer />
                {children}
              </AlertProvider>
            </ExpSessionProvider>
          </AddressProvider>
        </HandleAuth>
      </Theme>
    </Auth>
  )
}

export default PageProviders
